import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  MenuItem,
  Select,
} from "@mui/material";
import { Formik } from "formik";

import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import VuiInput from "components/VuiInput";
import VuiButton from "components/VuiButton";
import { AddUserSchema } from "validations";
import useCommon from "hooks/useCommon";
import { getRoles } from "store/slice/rolesSlice";
import { useEffect } from "react";
import VuiPhoneInput from "components/VuiPhoneInput";
import VuiAutocomplete from "components/AutoComplete";

const EditUserDialog = ({ open, user, onClose, onSave }) => {
  if (!user) return null;

  const { DISPATCH, NAVIFATE, STORE } = useCommon();
  const { updateLoading, updateError } = STORE((state) => state.user);
  const { roles } = STORE((state) => state.roles);
  const hotelId = STORE((state) => state.ui.hotelId);

  const handleSave = (values) => {
    const payload = {
      name: values.name,
      email: values.email,
      contactNumber: values.contactNumber,
      roleId: values.roleId,
      type: values.type,
      hotelId: values.hotelId.map((hotel) => hotel._id),
    };

    onSave?.(user._id, payload);
    resetForm();
  };

  useEffect(() => {
    DISPATCH(getRoles({ hotelId: hotelId }));
  }, [hotelId]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <VuiTypography variant="h6">Edit User</VuiTypography>
      </DialogTitle>

      <Formik
        enableReinitialize
        initialValues={{
          name: user.name || "",
          email: user.email || "",
          contactNumber: user.contactNumber || "",
          roleId: user.roleId?._id || "",
          type: user.type || "roleUser",
          hotelId: user.hotelId || [hotelId],
        }}
        validationSchema={AddUserSchema}
        onSubmit={(values, { resetForm }) => handleSave(values, resetForm)}
      >
        {({ values, errors, touched, handleChange, handleSubmit }) => (
          <>
            <DialogContent>
              {/* Full Name */}
              <VuiBox mb={2}>
                <VuiTypography variant="caption" ml={1}>
                  Full Name
                </VuiTypography>
                <VuiInput
                  textOnly
                  gradient
                  fullWidth
                  name="name"
                  value={values.name}
                  onChange={handleChange}
                  error={touched.name && !!errors.name}
                  inputProps={{ maxLength: 30 }}
                />
                {touched.name && errors.name && (
                  <VuiTypography variant="caption" color="error">
                    {errors.name}
                  </VuiTypography>
                )}
              </VuiBox>

              {/* Email */}
              <VuiBox mb={2}>
                <VuiTypography variant="caption" ml={1}>
                  Email
                </VuiTypography>
                <VuiInput
                  gradient
                  fullWidth
                  name="email"
                  type="email"
                  value={values.email}
                  onChange={handleChange}
                  error={touched.email && !!errors.email}
                />
                {touched.email && errors.email && (
                  <VuiTypography variant="caption" color="error">
                    {errors.email}
                  </VuiTypography>
                )}
              </VuiBox>

              {/* Contact Number */}
              <VuiBox mb={1}>
                <VuiPhoneInput
                  label="Contact Number"
                  value={values.contactNumber}
                  defaultCountry="US"
                  onChange={(value) =>
                    handleChange({
                      target: {
                        name: "contactNumber",
                        value,
                      },
                    })
                  }
                  error={touched.contactNumber && errors.contactNumber}
                />
              </VuiBox>

              {/* Role Selection */}
              <VuiBox mb={2}>
                <VuiTypography variant="caption" ml={1}>
                  Role
                </VuiTypography>

                <VuiAutocomplete
                  options={roles}
                  value={roles.find((r) => r._id === values.roleId) || null}
                  getOptionLabel={(option) => option.title}
                  isOptionEqualToValue={(opt, val) => opt._id === val._id}
                  placeholder="Select role"
                  gradient
                  onChange={(_, selected) => {
                    handleChange({
                      target: {
                        name: "roleId",
                        value: selected ? selected._id : "",
                      },
                    });
                  }}
                />

                {touched.roleId && errors.roleId && (
                  <VuiTypography variant="caption" color="error" ml={1}>
                    {errors.roleId}
                  </VuiTypography>
                )}

                {/* <Select
                  fullWidth
                  name="roleId"
                  value={values.roleId}
                  onChange={handleChange}
                  sx={{
                    height: 42,
                    color: "white",
                    ".MuiOutlinedInput-notchedOutline": {
                      borderColor:
                        touched.roleId && errors.roleId ? "#f44336" : "rgba(255,255,255,0.3)",
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: "white",
                    },
                    "& .MuiSvgIcon-root": {
                      color: "white",
                    },
                  }}
                >
                  {roles.map((role) => (
                    <MenuItem key={role._id} value={role._id}>
                      {role.title}
                    </MenuItem>
                  ))} */}
                {/* </Select> */}

                {/* {touched.roleId && errors.roleId && (
                  <VuiTypography variant="caption" color="error">
                    {errors.roleId}
                  </VuiTypography>
                )} */}
              </VuiBox>
            </DialogContent>

            <DialogActions>
              <VuiButton variant="outlined" color="primary" onClick={onClose}>
                Cancel
              </VuiButton>

              <VuiButton color="primary" onClick={handleSubmit} disabled={updateLoading}>
                {updateLoading ? "Saving..." : "Save Changes"}
              </VuiButton>
            </DialogActions>
          </>
        )}
      </Formik>
    </Dialog>
  );
};

export default EditUserDialog;
